import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const NotFound = () => {
  const { t } = useTranslation();

  return (
      <div className="md:mt-[150px] mt-[60px] max-w-prose mx-auto md:px-0 px-4">
        <div className="min-h-screen text-center">
          <h1 className="text-7xl font-extrabold dark:text-light pt-20 pb-4">404</h1>
          <h2 className="text-4xl font-bold text-dark-primary pb-8">
            {t('notfound.title')}
          </h2>
          <p className="text-2xl text-gray-700 dark:text-gray-300 max-w-2xl mx-auto pb-10">
            {t('notfound.description')}
          </p>
          <Link
              to="/"
              className="inline-block mt-4 px-8 py-3 bg-dark-primary text-white rounded-xl hover:bg-dark-primary/90 transition font-bold text-lg"
          >
            {t('notfound.back_home')}
          </Link>
        </div>
      </div>
  );
};

export default NotFound;